import { h } from 'preact';

const Newsletter = (props) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" role='img' {...props}>
			<path d="M23.775 10.526V5.101a1 1 0 00-1-1H8.301a1 1 0 00-1 1v5.425l-3.328 2.277a1.001 1.001 0 00-.435.825v13.473a1 1 0 001 1h22a1 1 0 001-1V13.628a1 1 0 00-.436-.825l-3.327-2.277zM8.301 5.101h14.474v11.175l-7.237 4.825-7.237-4.825V5.101zm-1 6.491v4.018l-3.013-2.009 3.013-2.009zm19.237 15.509h-22V14.97l10.445 6.963.555.37.555-.37 10.445-6.963v12.131zM23.775 15.61v-4.018l3.013 2.009-3.013 2.009zM10.538 8.101h10v-1h-10v1zm0 3h10v-1h-10v1zm0 3h5v-1h-5v1z" fill-rule="evenodd" clip-rule="evenodd" />
		</svg>
	);
};

export default Newsletter;
